import { toast } from 'react-toastify'
import branditRails from '../../../../api/brandit_rails'
import { updateCheckoutSessionTokenMultiAddress } from '../slice.checkoutSessionToken'
import { deleteCartItemAction, clearCartAction } from './cart.actions'

/**
 * Delete a cart item and sync multi-address selection to backend token
 * @param {number} cartItemId - The ID of the cart item to delete
 */
export const deleteCartItem = cartItemId => async (dispatch, getState) => {
  const resp = await branditRails.post(`/cart/delete/${cartItemId}`)

  if (resp && resp.status === 200) {
    // Clear multi-address selection for this item BEFORE updating cart items
    // This ensures the shipping group configuration won't include stale references
    // to the deleted cart item when the Cart.js useEffect fires
    dispatch({ type: 'CLEAR_MULTI_ADDRESS_SELECTION', payload: cartItemId })
    dispatch(deleteCartItemAction(resp.data))

    // Sync the updated multi-address selection to the backend token
    // This prevents stale cart item references when the user navigates back to checkout
    const state = getState()
    const token = state.checkoutSessionToken?.token
    if (token) {
      dispatch(updateCheckoutSessionTokenMultiAddress(token, state.checkout.multiAddressSelection))
    }
  } else {
    toast.error('Could not delete item from cart')
  }
}

/**
 * Clear all items from the cart
 * @param {number} locationId - The location ID for the cart to clear
 */
export const clearCart = locationId => async (dispatch, getState) => {
  const response = await branditRails.post('/cart/clear_all', { location_id: locationId }).catch(() => null)

  if (response?.status === 200 && response.data === true) {
    // Clear all multi-address selections since cart is now empty
    dispatch({ type: 'CLEAR_MULTI_ADDRESS_SELECTION' })
    dispatch(clearCartAction())
    toast.success('Your cart has been cleared')
    dispatch({ type: 'CLEAR_SWEETALERT' })

    // Sync the cleared multi-address selection to the backend token
    const state = getState()
    const token = state.checkoutSessionToken?.token
    if (token) {
      dispatch(updateCheckoutSessionTokenMultiAddress(token, []))
    }
    return true
  }
  toast.error("Sorry! We couldn't clear your cart. Please try again.")
  return false
}

/**
 * Clear cart items from local state only (no API call)
 * Used for local state reset scenarios
 */
export const clearCartItems = () => dispatch => {
  dispatch(clearCartAction())
}
